// src/components/VerifyEmail/AddEmail.jsx
// "Agregar email" a una cuenta de wallet (para avisos de trades + recuperación).
// Setea el email (sin verificar) y dispara el código; después el VerifyEmailPrompt
// aparece para ingresarlo. Se auto-oculta si la cuenta ya tiene email.
import React, { useState } from 'react';
import { FiMail, FiArrowRight } from 'react-icons/fi';
import { useAuth } from '../../Context/AuthContext';
import './VerifyEmailPrompt.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function AddEmail() {
  const { user, updateUser } = useAuth();
  const [email, setEmail]  = useState('');
  const [loading, setLoad] = useState(false);
  const [error, setError]  = useState('');

  // Solo cuentas con wallet y SIN email (los que entraron por wallet).
  if (!user?.walletAddress || user?.email) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { setError('Ingresá un email válido.'); return; }
    setLoad(true);
    try {
      const res  = await fetch(`${API_URL}/api/add-email`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body:    JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'No se pudo agregar el email.');
      // Al setear el email (sin verificar), aparece el prompt de verificación.
      updateUser(data.user || { email: email.trim().toLowerCase(), emailVerified: false });
    } catch (err) {
      setError(err.message === 'Failed to fetch' ? 'No se pudo conectar al servidor.' : err.message);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="ve">
      <div className="ve-head">
        <span className="ve-ic"><FiMail /></span>
        <div>
          <h3 className="ve-title">Agregá un email (opcional)</h3>
          <p className="ve-sub">
            Para recibir avisos de tus trades y tener una <strong>forma extra de recuperar tu acceso</strong>.
            No toca tu plata — solo tus mensajes.
          </p>
        </div>
      </div>
      <form className="ve-form" onSubmit={submit}>
        <input
          className="ve-input" type="email" placeholder="tu@email.com"
          style={{ letterSpacing: 'normal', textAlign: 'left', fontFamily: 'inherit', fontSize: '0.95rem' }}
          value={email} onChange={e => setEmail(e.target.value)} autoComplete="email"
        />
        <button type="submit" className="ve-btn" disabled={loading}>
          {loading ? <span className="ve-spin" /> : <>Agregar <FiArrowRight /></>}
        </button>
      </form>
      {error && <div className="ve-msg err">{error}</div>}
    </div>
  );
}
